export default {
  isAuthenticated (state, getters, rootState) {
    return state.token || false
  },
  token (state, getters, rootState) {
    return state.token || null
  },
  userBrand (state, getters, rootState) {
    return state.principal.user.brand || null
  },
  userName (state, getters, rootState) {
    return state.principal.user.username || null
  },
  userGroup (state, getters, rootState) {
    return state.principal.user.userGroup || null
  },
  userPartyGroups (state, getters, rootState) {
    return state.principal.partyGroups || []
  },
  userId (state, getters, rootState) {
    return state.principal.user.id || null
  },
  defaultCurrency (state, getters, rootState) {
    return state.principal.user.userGroup !== null ? state.principal.user.userGroup.defaultCurrency : null
  },
  defaultCountry (state, getters, rootState) {
    return state.principal.user.userGroup !== null ? state.principal.user.userGroup.defaultCountry : null
  },
  user (state, getters, rootState) {
    return state.principal.user || null
  },
  settings (state, getters, rootState) {
    return state.principal.settings || null
  },
  landingPage (state, getters, rootState) {
    const s = state.principal.settings.find(({settingType}) => settingType !== null && settingType.code === 'LANDING_PAGE')
    return s ? s.setting : null
  },
  userSettingsAdvisory (state, getters, rootState) {
    const s = state.principal.settings.find(({settingType}) => settingType !== null && settingType.code === 'ADVISORY')
    return s ? s.setting : null
  },
  role (state) {
    const user = state.principal.user
    return user && user.person && user.person.role
  },
  permissions (state) {
    const user = state.principal.user
    return user && user.person && user.person.role &&
      user.person.role.accessCodes ? user.person.role.accessCodes.split(',') : []
  }
}



// WEBPACK FOOTER //
// ./src/modules/authentication/store/getters.js